import { serviceApi } from '~/api/service';

export const partnersUrl = (string) => `partners${string}`;

export const partnersApi = {
  fetch: (url, options) => serviceApi.fetchJSON(partnersUrl(url), options),
};
